import simplonbpRegularTTF from 'assets/fonts/simplonbp-regular-webfont.ttf';
import simplonbpBoldTTF from 'assets/fonts/simplonbp-bold-webfont.ttf';
import { Overrides } from '@material-ui/core/styles/overrides';
const simplonbpRegular = {
  fontFamily: 'SimplonBp',
  fontStyle: 'normal',
  fontWeight: 400,
  src: `
    local('simplonbp'),
    local('simplonbp-Regular'),
    url(${simplonbpRegularTTF}) format('truetype')
  `,
};

const simplonbpBold = {
  fontFamily: 'SimplonBp',
  fontStyle: 'bold',
  fontWeight: 700,
  src: `
    local('simplonbp'),
    local('simplonbp-Bold'),
    url(${simplonbpBoldTTF}) format('truetype')
  `,
};

const MuiCssBaseline: Overrides['MuiCssBaseline'] = {
  '@global': {
    '@font-face': [simplonbpRegular, simplonbpBold],
  },
};

export default MuiCssBaseline;
